'use client';

import { clsxm } from '@cash-rewards/reactjs';
import clsx from 'clsx';
import Image, { ImageLoaderProps, ImageProps } from 'next/image';
import * as React from 'react';

export type NextImageProps = {
  useSkeleton?: boolean;
  imgClassName?: string;
  imgWrapperClassName?: string;
  blurClassName?: string;
} & ImageProps;

export default function NextImage({
  useSkeleton = false,
  src,
  width: _width,
  height: _height,
  alt,
  priority,
  className,
  imgClassName,
  imgWrapperClassName,
  blurClassName,
  loading = 'eager',
  fill,
  ...rest
}: NextImageProps) {
  const [status, setStatus] = React.useState(
    useSkeleton ? 'loading' : 'complete'
  );

  // Determine the image source based on availability

  const imageLoader = ({
    src: imgLoaderSrc,
    width: imgLoaderWidth,
    quality,
  }: ImageLoaderProps) => {
    return `${imgLoaderSrc}?auto=compress,format&fit=max&w=${imgLoaderWidth}&q=${
      quality || 40
    }`;
  };

  return (
    <figure className={clsx('relative w-full', className)}>
      {src && (
        <div className={clsxm(imgWrapperClassName)}>
          <Image
            className={clsxm(
              imgClassName,
              status === 'loading' && clsxm('animate-pulse', blurClassName)
            )}
            fill={fill}
            src={src}
            width={_width}
            height={_height}
            alt={alt}
            onLoadingComplete={() => setStatus('complete')}
            loader={imageLoader}
            loading={loading}
            priority={priority}
            sizes='(max-width: 768px) 100vw'
            {...rest}
          />
        </div>
      )}
    </figure>
  );
}
